export class BufferReader {
    public buffer: Buffer
    public offset: number

    constructor(buffer: Buffer) {
        this.buffer = buffer
        this.offset = 0
    }

    /**
     * @returns The amount of bytes you can read (offset dependant)
     */
    available(): number {
        return this.buffer.length - this.offset
    }

    skip(num: number) {
        this.offset += num
    }

    back(num: number) {
        this.offset -= num
    }

    readInt8() {
        const ret = this.buffer.readInt8(this.offset)
        this.offset += 1
        return ret
    }

    readInt16() {
        const ret = this.buffer.readInt16LE(this.offset)
        this.offset += 2
        return ret
    }

    readInt32() {
        const ret = this.buffer.readInt32LE(this.offset)
        this.offset += 4
        return ret
    }

    readInt64() {
        const ret = this.buffer.readBigInt64LE(this.offset)
        this.offset += 8
        return ret
    }

    readUInt8() {
        const ret = this.buffer.readUInt8(this.offset)
        this.offset += 1
        return ret
    }

    readUInt16() {
        const ret = this.buffer.readUInt16LE(this.offset)
        this.offset += 2
        return ret
    }

    readUInt32() {
        const ret = this.buffer.readUInt32LE(this.offset)
        this.offset += 4
        return ret
    }

    readUInt64() {
        const ret = this.buffer.readBigUInt64LE(this.offset)
        this.offset += 8
        return ret
    }

    readUint8Array(): Uint8Array {
        const length = this.readUInt16()

        const buffer = new Uint8Array(length)
        for (let i = 0; i < length; i++) {
            buffer[i] = this.readUInt8()
        }
        return buffer
    }

    readUint8ArrayByLength(length: number): Uint8Array {
        const buffer = new Uint8Array(length)
        for (let i = 0; i < length; i++) {
            buffer[i] = this.readUInt8()
        }
        return buffer
    }

    readString(): string {
        return new TextDecoder('utf-8').decode(this.readUint8Array())
    }

    readNullTerminatedString(maxLength = 255): string {
        const term = '\0'.charCodeAt(0)
        const buffer = new Uint8Array(maxLength)
        let length = 0
        for (let i = 0; i < maxLength; i++) {
            buffer[i] = this.readUInt8()
            if (buffer[i] === term) {
                length = i + 1
                break
            }
        }
        this.skip(maxLength - length)
        return new TextDecoder('utf-8').decode(buffer.slice(0, length - 1))
    }

    searchIndexOfString(str: string): number {
        for (let i = 0; i < 800; i++) {
            if (this.buffer[i] === str.charCodeAt(0)) {
                const strBuffer = new Uint8Array(str.length)
                for (let j = 0; j < str.length; j++) {
                    strBuffer[j] = this.buffer.readInt8(i + j)
                }
                const decodedStr = new TextDecoder('utf-8').decode(strBuffer)
                if (decodedStr === str) {
                    return i
                }
            }
        }
        return -1
    }
}
